import { ChangeDetectionStrategy, Component, Inject, Input, OnInit, Optional, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup, FormGroupDirective } from '@angular/forms';
import { MAT_BOTTOM_SHEET_DATA, MatBottomSheetRef } from '@angular/material/bottom-sheet';
import { AuthService } from '@klickdata/core/auth';
import { Customer } from '@klickdata/core/customer';
import { AppScope } from '@klickdata/core/resource';
import { Utils } from '@klickdata/core/util';
import { CustomerManagerResourcesSelectComponent } from 'apps/klickdata/src/app/master/customers/customer-manager/customer-manager-resources/customer-manager-resources-select/customer-manager-resources-select.component';
import { OnDestroyHandler } from 'apps/klickdata/src/app/shared/onDestroy-handler/onDestroy-handler';
import { filter, takeUntil } from 'rxjs';

@Component({
    selector: 'app-resources-select-cluster',
    templateUrl: './resources-select-cluster.component.html',
    styleUrls: ['./resources-select-cluster.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ResourcesSelectClusterComponent extends OnDestroyHandler implements OnInit {
    protected clusterControl: FormGroup;
    @ViewChild(CustomerManagerResourcesSelectComponent) selectComponent: CustomerManagerResourcesSelectComponent;
    AppScope = AppScope;
    @Input() columns: string[];

    constructor(
        @Optional() protected parentFormDirective: FormGroupDirective,
        protected fb: FormBuilder,
        protected auth: AuthService,
        public bottomSheetRef: MatBottomSheetRef<ResourcesSelectClusterComponent>,
        @Inject(MAT_BOTTOM_SHEET_DATA)
        public data: { customer: Customer; referencePropertyValue: string; referenceProperty: string }
    ) {
        super();
    }
    ngOnInit(): void {
        this.clusterControl = this.fb.group({});
        this.clusterControl.valueChanges.pipe(takeUntil(this.destroy)).subscribe(() => this.onChanged());
    }
    public canDeactivate(): boolean {
        return this.selectComponent ? this.selectComponent.canDeactivate() : true;
    }
    private onChanged() {
        this.clusterControl.markAsDirty();
    }
    public controlByScope(scope: AppScope, referenceKey: string): FormGroup {
        let customerForm = <FormGroup>this.clusterControl.get(scope.toString());

        if (!customerForm && referenceKey === 'referenceCluster') {
            customerForm = this.getGroup();
            this.clusterControl.addControl(scope.toString(), customerForm, { emitEvent: false });
        }
        return customerForm;
    }
    private getGroup() {
        return this.fb.group({
            id: [this.data.customer?.id],
            sync_all: [],
            attach_ids: [[]],
            detach_ids: [[]],
        });
    }
    protected onSubmit() {
        const value = this.clusterControl.value;
        const filteredValue: Record<string, { attach_ids: any[]; detach_ids: any[] }> = {};

        Object.keys(value).forEach((scope) => {
            const scopeValue = value[scope];
            if (scopeValue && (scopeValue.attach_ids || scopeValue.detach_ids)) {
                filteredValue[scope] = {
                    attach_ids: scopeValue.attach_ids || [],
                    detach_ids: scopeValue.detach_ids || [],
                };
            }
        });

        this.bottomSheetRef.dismiss(filteredValue);
    }
}
